import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, CircularProgress, List, ListItem, ListItemText, Chip, Tooltip } from '@mui/material';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

/**
 * Lista de categorias DNS que expiram em até 30 dias.
 * Click numa categoria → navega pra detalhe.
 */
export default function ExpiringCategoriesCard({ days = 30 }) {
    const navigate = useNavigate();
    const [state, setState] = useState({ loading: true, items: [] });

    useEffect(() => {
        api.get(`/dashboard/oceanide/expiring_categories?days=${days}`)
            .then((res) => setState({ ...res.data, loading: false }))
            .catch(() => setState({ loading: false, items: [] }));
    }, [days]);

    return (
        <Paper
            elevation={2}
            sx={{
                m: 2,
                p: 2,
                minHeight: 280,
                display: 'flex',
                flexDirection: 'column',
                borderLeft: '4px solid #ed6c02',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <HourglassBottomIcon sx={{ color: '#ed6c02' }} />
                <Typography variant="subtitle2" sx={{ textTransform: 'uppercase', fontWeight: 600 }}>
                    Expiram em ≤ {days} dias
                </Typography>
            </Box>

            {state.loading ? (
                <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CircularProgress size={28} />
                </Box>
            ) : state.items.length === 0 ? (
                <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                        Nenhuma categoria com expiração próxima
                    </Typography>
                </Box>
            ) : (
                <List dense sx={{ overflow: 'auto', maxHeight: 240, p: 0 }}>
                    {state.items.map((c) => {
                        const daysLeft = c.days_left;
                        const isExpired = daysLeft < 0;
                        const isUrgent = daysLeft >= 0 && daysLeft <= 3;
                        const color = isExpired ? 'error' : isUrgent ? 'error' : daysLeft <= 7 ? 'warning' : 'info';
                        const label = isExpired
                            ? `expirou há ${Math.abs(daysLeft)}d`
                            : daysLeft === 0
                            ? 'hoje'
                            : `${daysLeft}d`;
                        return (
                            <ListItem
                                key={c.id}
                                button
                                onClick={() => navigate(`/dns_blacklist/category/${c.id}`)}
                                sx={{ py: 0.5, borderRadius: 1, '&:hover': { bgcolor: 'action.hover' } }}
                            >
                                <ListItemText
                                    primary={c.name}
                                    secondary={`${c.domains_count} domínios`}
                                    primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}
                                    secondaryTypographyProps={{ variant: 'caption' }}
                                />
                                <Tooltip title={c.expired_at ? new Date(c.expired_at).toLocaleString('pt-BR') : ''}>
                                    <Chip size="small" label={label} color={color} variant="outlined" />
                                </Tooltip>
                            </ListItem>
                        );
                    })}
                </List>
            )}
        </Paper>
    );
}
